var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTravelJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Jobs",
    "data-name": "Controls/icon/Jobs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2258",
    "data-name": "Rectangle 2258",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2851",
    "data-name": "Group 2851",
    transform: "translate(0.999 4.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M45.09,18.8H38.759v-2.33a2.717,2.717,0,0,0-2.731-2.7H23.615a2.718,2.718,0,0,0-2.731,2.7V18.8H14.552a2.717,2.717,0,0,0-2.731,2.7V41.075a2.717,2.717,0,0,0,2.731,2.7H45.09a2.717,2.717,0,0,0,2.731-2.7V21.5A2.717,2.717,0,0,0,45.09,18.8Zm-21.723-2.33a.25.25,0,0,1,.248-.245H36.028a.249.249,0,0,1,.248.245V18.8H23.367ZM45.338,41.075a.249.249,0,0,1-.248.245H14.552a.25.25,0,0,1-.248-.245V21.5a.25.25,0,0,1,.248-.245H45.09a.249.249,0,0,1,.248.245Z",
    transform: "translate(-11.821 -13.772)",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M32.381,24.584H27.415V29.04H22.9v4.9h4.512V38.4h4.966V33.944h4.512v-4.9H32.381Z",
    transform: "translate(-11.897 -13.978)",
    fill: "#75787b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelJobs);
export default __webpack_public_path__ + "static/media/Travel-Jobs.b89981de6a6e87639ff4b4e67711407b.svg";
export { ForwardRef as ReactComponent };